import { render, staticRenderFns } from "./ExerciseItem.vue?vue&type=template&id=3883c363&scoped=true&"
import script from "./ExerciseItem.vue?vue&type=script&lang=js&"
export * from "./ExerciseItem.vue?vue&type=script&lang=js&"
import style0 from "./ExerciseItem.vue?vue&type=style&index=0&id=3883c363&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3883c363",
  null
  
)

export default component.exports